import React, { useMemo } from 'react';
import AudioPlayButton from '../Atoms/AudioPlayButton';
import AudioPauseButton from '../Atoms/AudioPauseButton';
import AudioPrevSenteceButton from '../Atoms/AudioPrevSentenceButton';
import AudioNextSentenceButton from '../Atoms/AudioNextSentenceButton';
import AudioLeadSentenceButton from '../Atoms/AudioLeadSentenceButton';
import AudioCompleteSentenceButton from '../Atoms/AudioCompleteSentenceButton';

import AudioRepeatCheckbox from '../Atoms/AudioRepeatCheckbox';
import AudioPlaybackSelect from '../Atoms/AudioPlaybackSelect';

import styles from './Player.module.scss';

type Props = {
  // 再生
  play: () => void;
  // 一時停止
  pause: () => void;
  // 再生中か
  isPlaying: boolean;
  // ループ変更
  toggleLoop: () => void;
  // ループするか
  isLoop: boolean;
  // トピックの先頭
  leadTopic: () => void;
  // トピックの完了
  completeTopic: () => void;
  // 再生速度
  playBackRate: number;
  // 再生速度変更
  changePlayBackRate: (rate: number) => void;
  // 次のセンテンス
  nextSentence: () => void;
  // 前のセンテンス
  prevSentence: () => void;
};

const Player = React.memo<Props>((props) => {
  // 再生速度メニュー
  const playBackRateMenu = useMemo(
    () => [
      {
        value: 0.8,
        title: '再生速度 0.8',
      },
      {
        value: 1,
        title: '再生速度 1.0',
      },
      {
        value: 1.3,
        title: '再生速度 1.3',
      },
    ],
    [],
  );

  return (
    <div className={styles['player-control-container']}>
      <div className={styles['player-control-container-outer']}>
        <div className={styles['player-control-container-upper']}>
          <div
            className={`${styles['player-control-container-inner']} ${styles['mod-left']}`}
          >
            <AudioPlaybackSelect
              defaultValue={props.playBackRate}
              onChnage={props.changePlayBackRate}
              menu={playBackRateMenu}
            />
          </div>
          <div
            className={`${styles['player-control-container-inner']} ${styles['mod-right']}`}
          >
            <AudioRepeatCheckbox
              defaultChecked={props.isLoop}
              toggleChecked={props.toggleLoop}
            />
          </div>
        </div>
        <div className={styles['player-control-container-bottom']}>
          <AudioLeadSentenceButton onClick={props.leadTopic} />
          <AudioPrevSenteceButton onClick={props.prevSentence} />
          {!props.isPlaying ? (
            <AudioPlayButton onClick={props.play} />
          ) : (
            <AudioPauseButton onClick={props.pause} />
          )}
          <AudioNextSentenceButton onClick={props.nextSentence} />
          <AudioCompleteSentenceButton onClick={props.completeTopic} />
        </div>
      </div>
    </div>
  );
});

export default Player;
